import About from "./Components/About";
import { Home } from "./Components/Home";
import NavBar from "./Components/NavBar";
import Skills from "./Components/Skills";
import Work from "./Components/Work";

function App() {
  return (
    <div>
      <NavBar />
      <Home />
      <About />
      <Skills />
      <Work />
    </div>
  );
}

export default App;
